import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';

@Component({
  selector: 'app-action-buttons-filter',
  standalone: true,
  imports: [CommonModule,MatButtonModule,MatMenuModule,MatIconModule,ButtonFilterTableClearComponent,MatTooltipModule,ButtonFilterTableComponent],
  templateUrl: 'action-buttons-filter.component.html',
  styleUrl: './action-buttons-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionButtonsFilterComponent {
  @Input() checkedFiltroAvanzado: boolean = false;
  @Input() menuFiltroAvanzado!: MatMenu;

  @Output() aplicarFiltro = new EventEmitter<void>();
  @Output() limpiarFiltro = new EventEmitter<void>();
  @Output() menuOpened = new EventEmitter<void>();
  @Output() menuClosed = new EventEmitter<void>();
}
